import module from './reset-password.module';

module.controller('ResetPasswordController', [
  'CurrentUserService',
  'UserAccountService',
  'LoginService',
  '$location',
  '$interval',
  function (CurrentUserService, UserAccountService, LoginService, $location, $interval) {
    var ctrl = this;

    $interval(() => {
      const el = document.querySelector('div.modal-resetpass');
      let isVisible = el.style.display === 'block';

      // we'll do some resetting when this modal is being closed
      if (!isVisible && ctrl.isVisible) {
        ctrl.init();
      }

      ctrl.isVisible = isVisible;
    }, 1000);

    ctrl.init = function () {
      ctrl.submitted = false;
      ctrl.buttonText = 'Reset Password';
      ctrl.success = false;
      ctrl.accountDoesNotExist = false;
      ctrl.usernameOrPasswordIncorrect = false;
      ctrl.errorMessage = '';
      ctrl.isVisible = false;
      ctrl.resetInfo = {
        email: '',
      };
    };

    ctrl.submit = function (resetInfo) {
      ctrl.submitted = true;
      ctrl.buttonText = 'Resetting...';
      ctrl.errorMessage = '';

      UserAccountService.forgotPassword(resetInfo.email)
        .then(
          function (data) {
            ctrl.success = data.success;

            if (!data.success) {
              ctrl.errorMessage = 'Hmm, we were unable to reset your password.  Are you sure you used the correct email address?';
            }

            // CurrentUserService.checkAuth(true).then(function (data) {
            //   $('.close').trigger('click');
            //   var nextState = LoginService.getNextPath();
            //   if (nextState) {
            //     $location.path(nextState);
            //   }
            // });

            console.warn(ctrl.errorMessage);
          },
          function (data) {
            ctrl.accountDoesNotExist = true;
          }
        )
        .finally(() => {
          ctrl.submitted = false;
          ctrl.buttonText = 'Reset Password';
        });
    };

    ctrl.init();
  },
]);
